import React from 'react';
import { Popup, SquareBorderButton, Icon } from '@lyearn-team/frontend-components';

import { PopupBody, BadgeImage, BadgeSubText, BadgeName, CloseBtn } from './BadgePopup.style';

export const BadgeView = ({ badge, show, onClose }) => {
  if (!badge || badge === 'null' || !badge.pid) {
    return null;
  }
  return (
    <Popup
      popupStyle={{ width: '580px', minWidth: '580px' }}
      header={null}
      onCloseClick={onClose}
      onOverlayClick={onClose}
      footer={null}
      showPopup={show}
      withPortal={true}
    >
      <PopupBody onClick={e => e.stopPropagation()}>
        <CloseBtn onClick={onClose}>
          <Icon type="close" height="16px" width="16px" />
        </CloseBtn>
        <BadgeImage src={badge.url} alt="" />
        <BadgeSubText>Congratulations! You have been awarded</BadgeSubText>
        <BadgeName>{badge.name}</BadgeName>
        <SquareBorderButton onClick={() => (window.location.href = '/#/user')}>
          Go to Profile
        </SquareBorderButton>
      </PopupBody>
    </Popup>
  );
};
